/**
 * GTM Analytics Utility
 * Pushes events and user data to the dataLayer for Google Tag Manager
 */

/**
 * Push an event to the dataLayer
 * @param {string} eventName - The event name (e.g., 'login', 'page_view')
 * @param {Object} params - Additional event parameters
 */
export const pushEvent = (eventName, params = {}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: eventName,
    ...params,
  });
};

/**
 * Identify the user after login or token-based authentication
 * Sets user properties that persist across the session
 * @param {Object} userData - The user object from AuthContext
 * @param {string} method - 'email' for login, 'token' for returning users
 */
export const identifyUser = (userData, method = 'email') => {
  if (!userData?.user?.wp_id) return;

  const subscriptionType =
    userData.new_subscriptions?.find((s) => ['active', 'trialing'].includes(s.status))?.plan_name ||
    userData.subscriptions?.find((s) => s.status === 'active')?.product_name ||
    'none';

  const leagueCount = userData.league_details?.length || 0;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: method === 'email' ? 'login' : 'user_identified',
    user_id: userData.user.wp_id,
    subscription_type: subscriptionType,
    league_count: leagueCount,
  });
};

/**
 * Track league switch event
 * @param {number} userId - The wp_id
 * @param {Object} league - The new active league
 */
export const trackLeagueSwitch = (userId, league) => {
  if (!userId || !league) return;

  pushEvent('league_switch', {
    user_id: userId,
    league_id: league.data?.league?.id,
    game_type: league.matchkeys?.game,
  });
};
